import * as React from "react";
import { Box, VStack } from "@chakra-ui/react";

/**
 * Illustrates the use of children prop and spread operator
 */
const FullScreenSection = ({ children, isDarkBackground, overlay = false, overlayColor = "whiteAlpha.800", ...boxProps }) => {
  return (
    <VStack
      backgroundColor={boxProps.backgroundColor}
      color={isDarkBackground ? "white" : "black"}
      backgroundImage={boxProps.backgroundImage}
      backgroundSize={boxProps.backgroundSize}
      backgroundPosition={boxProps.backgroundPosition}
      backgroundRepeat={boxProps.backgroundRepeat}
      width="100%"
      
    >
     
      <VStack width="100%" minHeight="60vh" {...boxProps} position="relative" zIndex={1}>
         {overlay && (
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bg={overlayColor}
          zIndex={0}
          pointerEvents="none"
        />
      )}
        {children}
      </VStack>
    </VStack>
  );
};

export default FullScreenSection;
